export const imageWidth = `64px`

export const olympiadPath = '/for-abiturients/olympiads'
